(function () {
  'use strict';

  var toggles = document.querySelectorAll('[data-cc-toggle]');
  if (!toggles.length) return;

  var form = document.querySelector('[data-cc-product-form]');

  toggles.forEach(function (root) {
    var pills = root.querySelectorAll('[data-cc-toggle-option]');
    var valueDisplay = root.querySelector('[data-cc-toggle-value]');
    var microcopy = root.querySelector('[data-cc-toggle-microcopy]');
    var property = root.dataset.property;
    var yesValue = root.dataset.yesValue || 'Yes';
    var noValue = root.dataset.noValue || '';
    var label = root.dataset.label || property;
    var helpVisibility = root.dataset.helpVisibility || 'always';
    var legacyEvent = root.hasAttribute('data-legacy-event');
    var required = root.hasAttribute('data-required');
    var input = null;

    function update(display) {
      var on = display === 'Yes';

      pills.forEach(function (pill) {
        var isSelected = pill.dataset.ccToggleOption === display;
        pill.classList.toggle('is-selected', isSelected);
        pill.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });

      if (valueDisplay) valueDisplay.textContent = display;
      if (microcopy && helpVisibility === 'when_on') microcopy.hidden = !on;
      root.classList.toggle('is-on', on);

      // properties[<property>] = yes_value when on, no_value when off;
      // omitted entirely when the off-value is empty (keeps Mal's CSV clean)
      var writeValue = on ? yesValue : noValue;
      if (writeValue) {
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + property + ']';
          form.appendChild(input);
        }
        input.value = writeValue;
      } else if (input) {
        input.remove();
        input = null;
      }

      document.dispatchEvent(new CustomEvent('cc:toggle-changed', {
        detail: { property: property, value: writeValue, label: label, on: on, required: required }
      }));

      // Legacy bridge: the upgrade_toggle instance feeds the variant
      // switcher's diamond axis through its original event, unchanged.
      if (legacyEvent) {
        document.dispatchEvent(new CustomEvent('cc:diamond-changed', {
          detail: { value: display }
        }));
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        update(this.dataset.ccToggleOption);
      });
    });

    // default-on toggles write their property at page load.
    // Default-off matches the old behavior exactly: no events, no input.
    if (root.hasAttribute('data-default-on')) {
      update('Yes');
    }
  });
})();
